import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { SplashScreens } from "@/components/Layout/SplashScreens/SplashScreens";
import { FullScreenLoadingProvider } from "@/provider/FullScreenLoadingProvider/FullScreenLoadingProvider";

import { SessionExpiredModal } from "./components/SessionExpiredModal";
import { clearLocalStorageOnce } from "./hooks/useClearLocalStorageOnFirstTab";
import { isAgentAtom } from "./utils/atoms";
import env from "./utils/environmentHelpers";

export const App = () => {
  const isAgent = useAtomValue(isAgentAtom);

  useEffect(() => {
    // agent handles localStorage cleaning itself, locally the heartbeat logic does not work correctly
    if (isAgent || env.isDev) {
      return;
    } else {
      return clearLocalStorageOnce();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FullScreenLoadingProvider>
      <SplashScreens />
      <div className="flex min-h-screen flex-col">
        <div
          data-testid="app"
          className="relative flex h-auto flex-grow flex-col overflow-hidden"
        >
          <Outlet />
        </div>
        <SessionExpiredModal />
      </div>
    </FullScreenLoadingProvider>
  );
};
